import React, {useState, useContext} from "react";
import __ from "lodash";
import {Button, IconButton, Tooltip} from '@material-ui/core';
import {HighlightOff, Receipt, Refresh} from '@material-ui/icons';
import {Stack} from "@mui/material";
import SystemContext from "../../../SystemContext";
import {ComboSelect, DatePicker, MaskedNumber, MaskedText} from "../../../controls";


const marginLeft = 10;
const formatChars={
  "U": "[A-Za-z*]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const emptySearch = {
  aircraftType: "B744",
  length: "",
  width: "",
  height: "",
}


const LoadabilityCheckSelector = (_props) => {
  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const props = {
    ..._props
  }

  const [search, setSearch] = useState(props.searchCriteria ?? emptySearch);

  const handleSearch = (aircraftType) => {
    if (eventBus) {
      eventBus.trigger('AircraftSideLoad.check',
        {
          aircraftType: aircraftType ? aircraftType : search.aircraftType||"B744",
          length: search.length||"null",
          width: search.width||"null",
          height: search.height ||"null",
        }
      );
      eventBus.trigger('AircraftNoseLoad.check',
        {
          length: search.length||"null",
          width: search.width||"null",
          height: search.height ||"null",
        }
      );
    }
  }

  const handleClearSelections = () => {
    setSearch(emptySearch);
    if (eventBus) {
      eventBus.trigger('AircraftSideLoad.check', {});
      eventBus.trigger('AircraftNoseLoad.check', {});
    }
  }

  const handleRefresh = () => {
    if (eventBus) {
      eventBus.trigger('AwbStockAllocationsList.refresh');
    }
  }

  return (
    <div style={{padding: "10px 20px", alignItems: "center",  justifyContent: "center",  width: "calc(100% - 20px)", display: "flex"}}>

      <div style={{width: 150, paddingLeft: 10}}>
        <ComboSelect
          group="AIRCRAFT TYPES"
          subGroup=""
          label="Aircraft Type"
          inputLabelProps={{ shrink: true }}
          value={search.aircraftType}
          fullWidth
          returnType={"objectOnly"}
          filter={(options)=>{return __.filter(options, (option) => !option.data?.excludeFromLoadabilityCheck) }}
          onChange={(returnObject) => {
            if (returnObject && !__.isEmpty(returnObject)) {
              setSearch({...search, aircraftType: returnObject.code});
              if (returnObject.code !== search.aircraftType) {
                handleSearch(returnObject.code);
              }
              if (eventBus) {
                eventBus.trigger('AircraftTypeSelection.set', returnObject.code);
              }
            }
          }}
        />
      </div>
      <div style={{width: 150, paddingLeft: 10}}>
        <MaskedText
          value={search.length}
          label="Length (Centimeters)"
          // inputLabelProps={{ shrink: true }}
          style={{width: "100%"}}
          mask={"9999"}
          maskChar={""}
          alwaysShowMask={false}
          formatChars={formatChars}
          forceUpperCase={false}
          onChange={(value)=> {setSearch({...search, length: value})}}
        />
      </div>
      <div style={{width: 150, paddingLeft: 10}}>
        <MaskedNumber
          value={search.width}
          label="Width (Centimeters)"
          // inputLabelProps={{ shrink: true }}
          decimalScale={0}
          fixedDecimalScale={true}
          thousandsGroupStyle=""
          thousandSeparator=","
          valueCap={999}
          allowLeadingZeros={true}
          format="###"
          onChange={(value)=> {setSearch({...search, width: value})}}
        />
      </div>
      <div style={{width: 150, paddingLeft: 10}}>
        <MaskedNumber
          value={search.height}
          label="Height (Centimeters)"
          // inputLabelProps={{ shrink: true }}
          decimalScale={0}
          fixedDecimalScale={true}
          thousandsGroupStyle=""
          thousandSeparator=","
          valueCap={999}
          allowLeadingZeros={true}
          format="###"
          onChange={(value)=> {setSearch({...search, height: value})}}
        />
      </div>

      <Stack direction="row" alignItems="center" spacing={0}>
        <Tooltip title={"Click to check loadability of cargo dimensions"}>
          <Button
            style={{marginLeft: 20}}
            startIcon={<Receipt />}
            color={"primary"}
            variant={"contained"}
            onClick={()=>{handleSearch()}}
            disabled={!search.length || !search.width || !search.height}
          >
            Check Loadability
          </Button>
        </Tooltip>
        <IconButton onClick={()=>{handleClearSelections()}} disabled={!search.length && !search.width && !search.height}>
          <Tooltip title={"Click to clear all selections"}>
            <HighlightOff style={{height: 32, width: 32, }} color="primary"/>
          </Tooltip>
        </IconButton>
        <IconButton onClick={()=>{handleRefresh()}}>
          <Tooltip title={"Refresh"}>
            <Refresh style={{height: 32, width: 32, }} color="primary"/>
          </Tooltip>
        </IconButton>
      </Stack>
    </div>
  )
}

export default LoadabilityCheckSelector;
